import styles from './Form.module.scss';

type FormCountProps = {
  id: string
  label: string
  checked?: boolean
  theme?: 'default' | 'primary'
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const FormCheckbox: React.FC<FormCountProps> = ({
  id,
  label,
  checked,
  theme = 'default',
  onChange
}) => {
  const formClassName = `form-check-${theme}`
  return (
    <div className={`form-check ${styles[formClassName]}`} id={`${id}-checkbox`}>
      <input 
        id={id} 
        className="form-check-input"
        type="checkbox" 
        onChange={onChange} 
        checked={checked}
        key={`checkbox-${checked}`}
      />
      <label className="form-check-label" htmlFor={id}>{label}</label>
    </div>
  )
}

export default FormCheckbox
